/**
 * Long-lived tabs keep running old JS after a deploy. Poll a tiny manifest from the
 * same origin; if it differs from the id baked into this bundle, hard-reload once.
 * Nginx should serve /build-info.json with Cache-Control: no-store.
 */
export function startClientVersionPolling() {
  if (process.env.NODE_ENV !== "production") return;
  const embedded = process.env.REACT_APP_BUILD_ID;
  if (!embedded || embedded === "local-dev") return;

  let cancelled = false;
  const poll = async () => {
    if (cancelled) return;
    try {
      const res = await fetch(`/build-info.json?t=${Date.now()}`, {
        cache: "no-store",
      });
      if (!res.ok) return;
      const data = await res.json();
      const serverId = data?.buildId;
      if (
        typeof serverId === "string" &&
        serverId.length > 0 &&
        serverId !== embedded
      ) {
        window.location.reload();
      }
    } catch {
      /* ignore — offline or transient */
    }
  };

  poll();
  setInterval(poll, 120_000);
  const onVisible = () => {
    if (document.visibilityState === "visible") poll();
  };
  document.addEventListener("visibilitychange", onVisible);
}
